import { Box, Fade, Grid, Typography, Link } from "@mui/material";
import safeBoxImage from "../../assets/withoutAcess/safeBox.png";

export function WithoutAccess() {
  function handleRedirectToSupport() {
    if (typeof window !== "undefined") {
      window.location.replace(
        "https://wa.me/551131810653?text=Ol%C3%A1+%21+Gostaria+de+saber+mais+sobre+o+CRM"
      );
    }
  }

  return (
    <Fade in>
      <Box
        height="96vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Você precisa conhecer essa novidade! 🎉
        </Typography>
        <Box marginTop="5vh">
          <Grid container spacing={0} alignItems="center">
            <Grid sx={{ display: "flex" }} item xs={6}>
              <img src={safeBoxImage} alt="safe-box" style={{ width: "30%" }} />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                Você não tem acesso a esse serviço, mas fique tranquilo!
              </Typography>
              <Typography variant="subtitle1">
                Para conhecer mais desse novo serviço, é só clicar{" "}
                <Link
                  onClick={() => handleRedirectToSupport()}
                  underline="always"
                >
                  aqui
                </Link>{" "}
                para falar com alguns dos nossos atendentes. 🤩
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fade>
  );
}
